import { useEffect } from 'react';
import { useActivities } from '../../hooks/useActivityTracking';

// Composant pour afficher un bouton de démonstration qui génère des activités de test
export function ActivityDemoButton() {
  const { addActivity } = useActivities();

  const generateTestActivity = () => {
    const activities = [
      {
        type: 'journal' as const,
        action: 'Nouvelle écriture ajoutée',
        description: 'Facture client DEMO SARL - 2,500,000 CDF',
        user: 'Demo User',
        status: 'success' as const,
        module: 'Journal'
      },
      {
        type: 'validation' as const,
        action: 'Validation ADHA',
        description: 'Écriture validée automatiquement',
        user: 'ADHA AI',
        status: 'success' as const,
        module: 'Agent Comptable'
      },
      {
        type: 'export' as const,
        action: 'Export PDF généré',
        description: 'Journal - Test de démonstration',
        user: 'Demo User',
        status: 'success' as const,
        module: 'Export'
      },
      {
        type: 'ledger' as const,
        action: 'Consultation grand livre',
        description: 'Compte 411000 - Clients démo',
        user: 'Demo User',
        status: 'success' as const,
        module: 'Grand Livre'
      }
    ];

    const randomActivity = activities[Math.floor(Math.random() * activities.length)];
    addActivity(randomActivity);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={generateTestActivity}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow-lg hover:bg-blue-700 transition-colors duration-150 text-sm font-medium"
      >
        ➕ Activité Test
      </button>
    </div>
  );
}

// Hook pour auto-générer des activités de démonstration
export function useActivityDemo() {
  const { addActivity, activities } = useActivities();

  useEffect(() => {
    // Générer une activité toutes les 30 secondes si moins de 5 activités
    const interval = setInterval(() => {
      if (activities.length < 5) {
        const demoActivities = [
          {
            type: 'calculation' as const,
            action: 'Calcul automatique',
            description: 'Mise à jour des ratios financiers',
            user: 'Système',
            status: 'success' as const,
            module: 'Dashboard'
          },
          {
            type: 'import' as const,
            action: 'Import automatique',
            description: 'Synchronisation données bancaires',
            user: 'Système',
            status: 'success' as const,
            module: 'Import'
          }
        ];

        const randomActivity = demoActivities[Math.floor(Math.random() * demoActivities.length)];
        addActivity(randomActivity);
      }
    }, 30000); // 30 secondes

    return () => clearInterval(interval);
  }, [activities.length, addActivity]);
}
